import { createRouter, createWebHistory } from 'vue-router';

const routes = [
  {
    id: 0,
    path: '/',
    // component: () => import('@/pages/PageOrders'),
    name: "mainPage",
  },
  {
    id: 1,
    path: '/orders',
    component: () => import('@/pages/PageOrders'),
    name: "Orders",
  },
  {
    id: 2,
    path: '/workers',
    component: () => import('@/pages/PageWorkers'),
    name: "Workers",
  },
  {
    id: 3,
    path: '/expenses',
    component: () => import('@/pages/PageExpenses'),
    name: "Expenses",
  },
  {
    id: 4,
    path: '/planer',
    component: () => import('@/pages/PagePlaner'),
    name: "Planer",
  },
  {
    id: 5,
    path: '/login',
    component: () => import('@/pages/PageLogin'),
    name: "Login",
  },
  {
    id: 6,
    path: '/regulars',
    component: () => import('@/pages/PageRegulars'),
    name: "Regulars",
  },
  {
    id: 7,
    path: '/statistics',
    component: () => import('@/pages/PageStatistics'),
    name: "Statistics",
  },
  
]

const router = createRouter({
  routes,
  history: createWebHistory(process.env.BASE_URL)
})

export default router
